import styles from "./Containers.module.css";
import closeIcon from "../../../assets/closeButton.svg";
import ActionButton from "../buttons/ActionButton";

const ImageList = ({
  photos,
  setPreview,
  deleteAllowed,
  removePhotoHandler,
}) => {
  return (
    <>
      <div className={styles.photosDiv}>
        {photos.map((photo) => (
          <div className={styles.photosContainer} key={photo.url}>
            <img
              className={styles.photos}
              src={photo.url}
              alt={photo.name}
              onClick={() => setPreview(photo)}
            />
            {deleteAllowed && (
              <div className={styles.actionButtonDiv}>
                <ActionButton
                  icon={closeIcon}
                  text="removePhoto"
                  onClick={() => removePhotoHandler(photo)}
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default ImageList;
